export enum Language {
  en = 'en',
  ru = 'ru',
  az = 'az',
}
